import { orientationTypeToRotationMap, } from './getIosFrameRotation';
export function getIosPreviewRotation(orientation, frontCamera) {
    const rotation = orientationTypeToRotationMap[orientation.type];
    return frontCamera ? (rotation + 180) % 360 : rotation;
}
